import { render, staticRenderFns } from "./StaffAccess.vue?vue&type=template&id=22412b44"
import script from "./StaffAccess.vue?vue&type=script&lang=js"
export * from "./StaffAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports